import { render, staticRenderFns } from "./NewOnboarding.vue?vue&type=template&id=6ac8931b&scoped=true&"
import script from "./NewOnboarding.vue?vue&type=script&lang=ts&"
export * from "./NewOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./NewOnboarding.vue?vue&type=style&index=0&id=6ac8931b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8931b",
  null
  
)

export default component.exports